import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ScenarioChart from 'Components/ComponentLibrary/Organisms/ScenarioChart';
import { FDContentContainer } from '@facet-wealth/design';
import ViewScenarioButtonPicker from '../ViewScenarioButtonPicker';

const styles = theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  chartWrapper: {
    flex: 1,
    padding: theme.spacing(4),
    width: '100%',
  },
});

const ActiveScenarioChartContent = ({ className, classes }) => {
  const { clientDashboardResource } = useDashboardContext();

  return (
    <Box className={classNames(classes.root, className)}>
      <Box className={classes.chartWrapper}>
        <FDContentContainer maxWidth="xl">
          <ScenarioChart
            height={380}
            resource={clientDashboardResource}
            isMultiChart
          />
          <ViewScenarioButtonPicker />
        </FDContentContainer>
      </Box>
    </Box>
  );
};

ActiveScenarioChartContent.defaultProps = {
  className: '',
};

ActiveScenarioChartContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ActiveScenarioChartContent);
